import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './card.module.less';
import {Avatar} from 'antd';
import {judge} from '@/page/conversation/ConPage/Content/Utils';
import ChatRecordModal from '@/page/conversation/ConPage/Content/ChatRecordModal';
import _ from 'lodash';
import {getMemberDetail} from '@/api/room';
import dayjs from 'dayjs';

function ContentCard({content, receive, from, fromType, openDetail}) {
    const modalRef = useRef();
    const [data, setData] = useState(null);
    const [chatRecords, setChatRecords] = useState([]);
    useEffect(() => {
        if (!_.isEmpty(receive) && !_.isEmpty(from) && !_.isEmpty(content)) initData();
        else setData(null);
    }, [receive, from, content]);

    function initData() {
        let data = judge(content, from, receive, fromType);
        setData(data);
    }

    function openChatRecord(records) {
        setChatRecords(records);
        modalRef.current.open();
    }

    function getDetail(chatId, from) {
        getMemberDetail(chatId, from).then(res => {
            console.log('user', res);
            openDetail(res.data);
        });
    }

    if (data) {
        let {type, avatar, contentTemp, name, content} = data;
        const {msgtype, from, roomid, msgtime} = content;
        return (
            <div className={styles.card}>
                <ChatRecordModal ref={modalRef} chatRecords={chatRecords} />
                <div
                    className={classNames(styles.avatar, {
                        [styles.right]: type === 1,
                    })}
                >
                    <Avatar
                        src={avatar}
                        shape="square"
                        size="large"
                        onClick={() => roomid && getDetail(roomid, from)}
                    />
                </div>
                <div
                    className={classNames(styles.content, {
                        [styles.right]: type === 1,
                    })}
                >
                    <div
                        className={classNames(styles.name, {
                            // [styles.textRight]: type === 1,
                        })}
                    >
                        {type !== 1 && name}
                        {dayjs(parseInt(msgtime)).format('MM-DD HH:mm:ss')}
                    </div>
                    <div
                        className={classNames(styles.desc, {
                            [styles.rightDesc]: type === 1 && msgtype === 'text',
                            [styles.medias]:
                                msgtype == 'redpacket' ||
                                msgtype == 'external_redpacket' ||
                                msgtype == 'emotion' ||
                                msgtype == 'image' ||
                                msgtype == 'video',
                        })}
                    >
                        {msgtype === 'chatRecord' ? (
                            <div onClick={() => openChatRecord(content.chatRecord.item)}>
                                {contentTemp}
                            </div>
                        ) : (
                            contentTemp
                        )}
                        {msgtype !== 'redpacket' &&
                            msgtype !== 'external_redpacket' &&
                            msgtype !== 'emotion' &&
                            msgtype !== 'image' &&
                            msgtype !== 'video' && (
                                <div
                                    className={classNames(styles.tri, {
                                        [styles.right]: type === 1 && msgtype === 'text',
                                        [styles.rightColor]: type === 1 && msgtype !== 'text',
                                        [styles.left]: type === 0,
                                    })}
                                />
                            )}
                    </div>
                </div>
            </div>
        );
    } else {
        return null;
    }
}

ContentCard.propTypes = {
    content: PropTypes.object,
    receive: PropTypes.object,
    from: PropTypes.object,
    fromType: PropTypes.number,
    openDetail: PropTypes.func,
};

export default ContentCard;
